import React from 'react';

const LinkIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="#83AFE5"
    width="18"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 1q1.18 0 2.277 0.445t1.965 1.312 1.313 1.965 0.445 2.277q0 1.172-0.449 2.277t-1.309 1.965l-3 3q-0.086 0.086-0.258 0.242-0.836 0.742-1.867 1.129t-2.117 0.387q-1.367 0-2.586-0.586-0.914-0.43-1.656-1.172t-1.172-1.656q0.586-0.586 1.414-0.586 0.289 0 0.586 0.086 0.508 0.82 1.328 1.328 0.961 0.586 2.086 0.586 0.781 0 1.516-0.297t1.313-0.875l3-3q0.578-0.578 0.875-1.313t0.297-1.516-0.297-1.516-0.875-1.313-1.313-0.875-1.516-0.297-1.516 0.297-1.313 0.875l-2.102 2.102q-1-0.273-2.070-0.273-0.172 0-0.484 0.016 0.156-0.172 0.242-0.258l3-3q0.859-0.859 1.965-1.309t2.277-0.449zM10 8q1.367 0 2.586 0.586 0.914 0.43 1.656 1.172t1.172 1.656q-0.586 0.586-1.414 0.586-0.289 0-0.586-0.086-0.508-0.82-1.328-1.328-0.961-0.586-2.086-0.586-0.781 0-1.516 0.297t-1.313 0.875l-3 3q-0.578 0.578-0.875 1.313t-0.297 1.516 0.297 1.516 0.875 1.313 1.313 0.875 1.516 0.297 1.516-0.297 1.313-0.875l2.102-2.102q1 0.273 2.070 0.273 0.172 0 0.484-0.016-0.156 0.172-0.242 0.258l-3 3q-0.867 0.867-1.965 1.313t-2.277 0.445q-1.172 0-2.277-0.449t-1.965-1.309q-0.867-0.867-1.313-1.965t-0.445-2.277 0.445-2.277 1.313-1.965l3-3q0.086-0.086 0.258-0.242 0.836-0.742 1.867-1.129t2.117-0.387z" />
  </svg>
);

export default LinkIcon;



// WEBPACK FOOTER //
// ./src/svg/LinkIcon.js